// base library
import {
    ConfigProvider,
    Layout,
    Input,
    InputNumber,
    Button,
    Radio,
    Checkbox,
    Select,
    Card,
    Form,
    Row,
    Col,
    Modal,
    Table,
    Tabs,
    Icon,
    Popover,
    Dropdown,
    Avatar,
    Breadcrumb,
    Spin,
    Menu,
    Tooltip,
    Tag,
    Divider,
    DatePicker,
    Upload,
    Progress,
    Skeleton,
    Popconfirm,
    message,
    Empty,
    TreeSelect,
    Space,
    FormModel,
    Collapse,
    Tree,
    Drawer,
    Switch,
    Slider,
    AutoComplete,
    Cascader,
    Result,
    Affix,
    Pagination,
    Steps,
    Alert,
    Timeline,
    Descriptions
} from "ant-design-vue"

export default function(Vue: any) {
    Vue.use(ConfigProvider)
    Vue.use(Layout)
    Vue.use(Input)
    Vue.use(InputNumber)
    Vue.use(Button)
    Vue.use(Radio)
    Vue.use(Checkbox)
    Vue.use(Select)
    Vue.use(Card)
    Vue.use(Form)
    Vue.use(Row)
    Vue.use(Col)
    Vue.use(Modal)
    Vue.use(Table)
    Vue.use(Tabs)
    Vue.use(Icon)
    Vue.use(Popover)
    Vue.use(Dropdown)
    Vue.use(Avatar)
    Vue.use(Breadcrumb)
    Vue.use(Spin)
    Vue.use(Menu)
    Vue.use(Tooltip)
    Vue.use(Tag)
    Vue.use(Divider)
    Vue.use(DatePicker)
    Vue.use(Upload)
    Vue.use(Progress)
    Vue.use(Skeleton)
    Vue.use(Popconfirm)
    Vue.use(Empty)
    Vue.use(TreeSelect)
    Vue.use(Tree)
    Vue.use(Space)
    Vue.use(FormModel)
    Vue.use(FormModel.Item)
    Vue.use(Collapse)
    Vue.use(Collapse.Panel)
    Vue.use(Drawer)
    Vue.use(Switch)
    Vue.use(Slider)
    Vue.use(AutoComplete)
    Vue.use(Cascader)
    Vue.use(Result)
    Vue.use(Affix)
    Vue.use(Pagination)
    Vue.use(Steps)
    Vue.use(Alert)
    Vue.use(Timeline)
    Vue.use(Descriptions)

    Vue.prototype.$confirm = Modal.confirm
    Vue.prototype.$message = message
    Vue.prototype.$info = Modal.info
    Vue.prototype.$success = Modal.success
    Vue.prototype.$error = Modal.error
    Vue.prototype.$warning = Modal.warning
}
